import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import App from './App.vue';
import router from './router';
Vue.config.productionTip = false;
import { Pagination } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.imghttp = function (url) {
	return `https://xcx.sxlgw.cn:891/profile/upload/xcx/${url}`;
};
Vue.prototype.imghttps = function (url) {
	return `https://xcx.sxlgw.cn:891/${url}`;
};
Vue.use(Pagination);
Vue.use(VueAwesomeSwiper);
new Vue({
	router,
	render: h => h(App),
}).$mount('#app');